import { ColorIcon, colors } from "goi_common";
import { HTMLAttributes } from "react";

interface Props extends HTMLAttributes<HTMLButtonElement> {
  showRightArrowIcon?: boolean;
  className?: string;
}

const RoundButton = (props: Props) => {
  const { children, showRightArrowIcon, className = "button_14_sb", ...rest } = props;

  return (
    <button
      className={className}
      css={{
        padding: "12px 16px",
        border: `1px solid ${colors.gray600}`,
        borderRadius: "20px",
        display: "flex",

        gap: "10px",
      }}
      {...rest}
    >
      {children}
      {showRightArrowIcon && (
        <ColorIcon color={colors.white} size={16} name="icon-arrow-right-small-mono" />
      )}
    </button>
  );
};

export default RoundButton;
